import type { LooseObject } from '~/types/generic';

export const sendUserSignupEvent = (userId: string): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'sign_up', user_id: userId });
};

export const sendUserLoginEvent = (userId: string): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'login', user_id: userId });
};

export const sendPurchaseEvent = (purchaseEventVars: LooseObject) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      ...purchaseEventVars,
    },
  });
};

export const sendMobileFunnelStepEvent = (event: string, additionalData = {}): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...additionalData });

  // console.log('DATALAYER PUSH', { event, ...additionalData });
};
